import { render } from "./ExpenseItem.vue?vue&type=template&id=9fda2d94&scoped=true&ts=true"
import script from "./ExpenseItem.vue?vue&type=script&lang=ts"
export * from "./ExpenseItem.vue?vue&type=script&lang=ts"

import "./ExpenseItem.vue?vue&type=style&index=0&id=9fda2d94&scoped=true&lang=css"

import exportComponent from "C:\\Users\\EugenePrice\\repos\\thinkspatial\\expenses-ionic-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9fda2d94"]])

export default __exports__